/** A new slip. Nothing is written -- and no number is spent -- until the first Post. */
import { LOT_BLENDING_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { LotBlendingPage } from "@/features/processing/components/lot-blending-page";

export const Route = createFileRoute("/_app/processing/blending/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(LOT_BLENDING_FORM))
      throw redirect({ to: "/processing/blending" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  const plantName = selected
    ? `${selected.name} (${selected.plantCode})`
    : null;
  return (
    <LotBlendingPage
      slip={null}
      facilityId={selected?.id}
      plantName={plantName}
    />
  );
}
